import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { EditMediaComponent } from './edit-media/edit-media.component';
import { AppConfig } from 'src/app/core/configs/app.config';

export interface MediasList {
    media: number;
    image: string;
    ch1455: string;
    ch1456: string;
    ch1686: string;
    ch1755: string;
    ch1559: string;
}

@Component({
    selector: 'app-medias-overview',
    templateUrl: './medias-overview.component.html',
    styleUrls: ['./medias-overview.component.scss']
})
export class MediasOverviewComponent implements OnInit {
    /** table  **/
    public ELEMENT_DATA: MediasList[] = [
        {
            media: 1,
            image: 'infiniti.jpg',
            ch1455: 'generic',
            ch1456: null,
            ch1686: null,
            ch1755: 'rainy days',
            ch1559: null
        },
        {
            media: 2,
            image: 'etisalat-5g.jpg',
            ch1455: 'generic',
            ch1456: null,
            ch1686: 'sunny',
            ch1755: 'rainy days',
            ch1559: null
        },
        {
            media: 3,
            image: 'infiniti.jpg',
            ch1455: 'generic',
            ch1456: null,
            ch1686: null,
            ch1755: 'rainy days',
            ch1559: null
        },
        {
            media: 4,
            image: 'etisalat-5g.jpg',
            ch1455: 'generic',
            ch1456: null,
            ch1686: null,
            ch1755: 'rainy days',
            ch1559: null
        }
    ];

    displayedColumns: string[] = [
        'media',
        'image',
        'CH-1455',
        'CH-1456',
        'CH-1686',
        'CH-1755',
        'CH-1559',
        'edit'
    ];

    dataSource = new MatTableDataSource<MediasList>(this.ELEMENT_DATA);

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    public constructor(public dialog: MatDialog) {}

    ngOnInit(): void {}

    public getImgSrc(img): string {
        return `./assets/images/${img}`;
    }

    public editMedia(element) {
        const dialogRef = this.dialog.open(EditMediaComponent, {
            width: AppConfig.dialog_width,
            maxHeight: AppConfig.dialog_max_height,
            data: {
                element: element
            }
        });
    }
}
